import http from '@/http'
const URL = '/admin/store'

export const list = async (params) => {
  const list = (await http.get(URL + `/products`, { params: params }))
  return list
}

export const getCategories = async (params) => {
  const list = (await http.get(URL + `/categories`, { params: params }))
  return list
}

export const find = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/products/${id}`))
  }
  return one
}

export const findCategory = async (params) => {
  let one = null
  if (params.id) {
    one = (await http.get(URL + `/categories/${params.id}`))
  }
  return one
}

export const save = (payload) => {
  let id = ''
  if (payload.get('id') > 0) {
    id = payload.get('id')
  }

  return http.post(URL + `/products/${id}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const saveCategory = (payload) => {
  let id = payload.id || ''
  return http.post(URL + `/categories/${id}`, payload)
}

export const orderList = async (payload) => http.put(URL + `/products/sequence?include=category`, payload)
export const deleteProduct = async (payload) => http.delete(URL + `/products/${payload.id}`)
export const deleteCategory = async (payload) => http.delete(URL + `/categories/${payload.id}`)
export const changeStatus = (payload) => http.put(URL + `/products/${payload.id}/status`, payload)

export default {
  list,
  getCategories,
  saveCategory,
  find,
  findCategory,
  save,
  changeStatus,
  deleteProduct,
  deleteCategory,
  orderList
}
